import React from "react";
import { Link } from "react-scroll";

export default function HeroSection() {
  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-cream-50 via-cream-100 to-cream-200 pt-24 lg:pt-20"
      id="home"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d47a2a' fill-opacity='0.3'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      {/* Decorative shapes */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cream-300 rounded-full blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-cream-400 rounded-full blur-3xl opacity-15 translate-x-1/3 translate-y-1/3" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left space-y-8">
            {/* Quote Block */}
            <div className="relative">
              <div className="absolute -top-6 -left-2 md:-top-8 md:-left-4 lg:-top-12 lg:-left-8 text-6xl sm:text-7xl md:text-8xl lg:text-9xl text-cream-400 opacity-30 font-serif select-none">
                "
              </div>
              <blockquote className="relative z-10 animate-fadeInUp">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-charcoal-800">
                  Nie ma bardziej szczerej miłości niż miłość do{" "}
                  <span className="text-cream-700 relative inline-block">
                    jedzenia
                    <svg
                      className="absolute -bottom-1 left-0 w-full"
                      viewBox="0 0 300 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 9C2 9 75 3 150 3C225 3 298 9 298 9"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                </h1>
                <footer className="mt-6">
                  <cite className="text-lg md:text-xl text-charcoal-600 font-medium not-italic flex items-center gap-2">
                    <span className="w-8 h-px bg-cream-500" />
                    George Bernard Shaw
                  </cite>
                </footer>
              </blockquote>
            </div>

            {/* Description */}
            <div className="space-y-6 animate-fadeInUp animation-delay-200">
              <p className="text-lg md:text-xl text-charcoal-600 leading-relaxed">
                Nie powiemy Ci, że z nami odkryjesz swoją pasję do gotowania.
                Nie powiemy, że na pewno kochasz wyjątkowe potrawy.
              </p>
              <p className="text-lg md:text-xl text-charcoal-700 font-semibold">
                Zamiast mówić, zrobimy to, co robimy najlepiej:
                <span className="text-cream-700 block mt-2 text-2xl">
                  przygotujemy catering specjalnie dla Ciebie.
                </span>
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 pt-6 animate-fadeInUp animation-delay-400">
              <Link
                to="menu2"
                smooth={true}
                duration={500}
                offset={-80}
                className="group cursor-pointer"
                aria-label="Zobacz nasze menu"
              >
                <button className="relative bg-cream-700 hover:bg-cream-800 text-white font-semibold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-100 shadow-lg hover:shadow-xl overflow-hidden">
                  <span className="relative z-10 flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                    Zobacz Menu
                  </span>
                  <div className="absolute inset-0 bg-cream-800 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left " />
                </button>
              </Link>

              <Link
                to="offerweek"
                smooth={true}
                duration={500}
                offset={-80}
                className="group cursor-pointer"
                aria-label="Sprawdź ofertę tygodnia"
              >
                <button className="relative bg-white hover:bg-cream-50 hover:text-white text-charcoal-700 font-semibold py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-100 shadow-lg hover:shadow-xl border-2 border-cream-300 overflow-hidden">
                  <span className="relative z-10 flex items-center gap-2">
                    Oferta tygodnia
                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                  </span>
                  <div className="absolute inset-0 bg-cream-800 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-right color-white" />
                </button>
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-6 pt-8 text-sm text-charcoal-600 animate-fadeInUp animation-delay-600">
              <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full">
                <svg
                  className="w-5 h-5 text-cream-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="font-medium">Od 2012 roku</span>
              </div>
              <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full">
                <svg
                  className="w-5 h-5 text-cream-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="font-medium">Setki zadowolonych klientów</span>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative lg:pl-8 animate-fadeInRight animation-delay-200">
            {/* Decorative Elements */}
            <div className="absolute -top-8 -right-8 w-72 h-72 bg-cream-300 rounded-full opacity-30 blur-3xl" />
            <div className="absolute -bottom-12 -left-12 w-96 h-96 bg-cream-400 rounded-full opacity-20 blur-3xl" />

            {/* Main Image Container */}
            <div className="relative">
              <div className="relative overflow-hidden rounded-3xl shadow-2xl bg-cream-200">
                <img
                  src="images/hero.png"
                  alt="Wykwintne dania cateringowe przygotowane przez Anatomia Smaku"
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-700"
                  loading="eager"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/20 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-5 transform rotate-3 hover:rotate-0 transition-all duration-300 ease-in-out hover:shadow-2xl border border-gray-100">
                <div className="flex items-center gap-4">
                  <div>
                    {/* Gwiazdki */}
                    <div className="flex gap-1">
                      {[...Array(4)].map((_, index) => (
                        <svg
                          key={index}
                          className="w-6 h-6 text-yellow-400 hover:scale-110 hover:text-yellow-500 transition-transform duration-200"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                      ))}
                      {/* Pół-gwiazdka */}
                      <div className="relative w-6 h-6">
                        <svg
                          className="absolute top-0 left-0 w-6 h-6 text-yellow-400 hover:scale-110 hover:text-yellow-500 transition-transform duration-200"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ clipPath: "inset(0 50% 0 0)" }}
                        >
                          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                        <svg
                          className="absolute top-0 left-0 w-6 h-6 text-gray-300 hover:scale-110 transition-transform duration-200"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ clipPath: "inset(0 0 0 50%)" }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p className="text-xs text-charcoal-500 font-medium mt-1">
                      Ocena klientów
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden lg:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <div className="bg-white/80 backdrop-blur-sm rounded-full p-3 shadow-lg">
          <svg
            className="w-6 h-6 text-cream-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
